<template>
  <the-section :title="$t('ec-line042.section.title')" class="purchase-item-section">
    <el-row>
      <template>
        <purchase-items
          v-for="(item, index) in data"
          :ref="item.ref"
          :key="item.id"
          :data="item"
          :is-last-item="data.length === index + 1"
        ></purchase-items>
      </template>
    </el-row>
  </the-section>
</template>

<script>
import TheSection from '@/components/my-page-partials/TheSection.vue'
import PurchaseItems from '@/components/ec-line042/PurchaseItems.vue'

export default {
  name: 'PurchaseInformation',
  components: { TheSection, PurchaseItems },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
